import { useMainStore } from "../../pinia/main";
import { useRoute, useRouter } from "vue-router";
import { onMounted, getCurrentInstance, reactive } from "vue";
export default {
  name: "privacypolicy",
  setup() {
    const router = useRouter();
    const route = useRoute();
    const mainStore = useMainStore();
    const internal = getCurrentInstance();
    const globalProperties = internal?.appContext.config.globalProperties;
    const data = reactive({
      tabsIndex: 0,
      list: [{
        label: "用户服务协议",
        items: [{
          label: "用户服务协议",
          src: "https://dev.tianchenhulian.com/protocol/index.html?keyword=UPN_consigner",
          view: false
        }]
      }, {
        label: "用户隐私政策",
        items: [{
          label: "个人隐私政策",
          src: "https://dev.tianchenhulian.com/protocol/index.html?keyword=PP_consigner",
          view: false
        }]
      }]
    });
    onMounted(() => {});
    const changeTabs = index => {
      data.tabsIndex = index;
    };
    const setTargetView = index => {
      data.list[data.tabsIndex].items[index].view = !data.list[data.tabsIndex].items[index].view;
    };
    return {
      mainStore,
      data,
      changeTabs,
      setTargetView
    };
  }
};